import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { Dialog } from 'components/Dialog/Dialog'
import { LargeButton } from 'components/LargeButton/LargeButton'
import { TextControl } from 'components/TextControl/TextControl';
import { getRequest } from 'core/axios/axios';
import { useAction } from 'core/store/store';
import { Endpoint } from 'Endpoint';
import React, { useState } from 'react'
import { makeAuthLoginWithJwtAction } from 'state/auth/actions';
import { makeSnackbarErrorAction } from 'state/snackbar/actions';

const useStyles = makeStyles(theme => ({
    container: {
        paddingBottom: theme.spacing(3)
    },
    buttonWrapper: {
        marginTop: theme.spacing(2),
    },
    buttonDisabled: {
        pointerEvents: 'none',
        opacity: 0.7,
    },
}));

interface IAdminLoginProps {
    onClose: () => void;
}

export const AdminLogin: React.FC<IAdminLoginProps> = ({ onClose }) => {
    const action = useAction();

    const [vendorJwt, setVendorJwt] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    
    const handleLoginVendorWithJwt = async () => {
        if (!vendorJwt) {
            return;
        }
        try {
            setIsLoading(true);
            const { data } = await getRequest(Endpoint.PROFILE, { Authorization: vendorJwt });
            action(makeAuthLoginWithJwtAction, data.phoneNumber, vendorJwt);
        } catch (e) {
            setIsLoading(false);
            action(makeSnackbarErrorAction, 'auth:errors.error')
        }
    }

    const classes = useStyles();
    
    return (
        <Dialog title="Login as vendor" contentStyles={classes.container} onClose={onClose}>
            <TextControl label="Vendor JWT" value={vendorJwt} onChange={e => setVendorJwt(e.target.value)} />

            <div className={classes.buttonWrapper}>
                <LargeButton 
                    disabled={isLoading} 
                    className={clsx({ [classes.buttonDisabled]: isLoading })} 
                    onClick={handleLoginVendorWithJwt}
                >
                    Login
                </LargeButton>
            </div>
        </Dialog>
    )
}
